<template>
  <transition name="fade">
      <div class="container">
        <Header v-if="isLogged()" />
        <div class="gap">
          <router-view />
        </div>
      </div>
  </transition>
</template>

<script>
import Header from './components/Header';
import 'bootstrap-css-only/css/bootstrap.min.css'; 
import 'mdbvue/build/css/mdb.css';

export default {
    name: 'App',
    data: function() {
        return {
          isLoggedIn: false
        }
    },
    components: {
      Header
    },
    mounted() {
        if(!this.isLoggedIn) {
          this.$router.replace({ name: "Login" });
        } 
    },
    methods: {
        isLogged() {
          this.isLoggedIn = (this.$localStorage.get('token') != null);
          return this.isLoggedIn;
        }
    },
    created: function () {
      this.$http.interceptors.response.use(undefined, function (err) {
        return new Promise(function (resolve, reject) {
          if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
            this.isLoggedIn = false;
            this.$store.dispatch('logout');
          }
          throw err;
        });
      });
    },
}
</script>

<style lang="scss" scoped>
    @import './assets/styles/_app.sass';

    @media (min-width: 1200px) {
      .container {
        max-width: 1300px !important;
      }
    }
</style>